import { Volume } from '~/shared/types/api';
import { toaster } from '~/shared/utils/toaster';
import { SelectOption } from '~/shared/utils/types';

export const baseUrl = `/api/v1/volumes`;

export const canBeDatafied = (v: Volume) =>
  ['gp2', 'gp3'].includes(v?.diskType || '') &&
  ['Monitored'].includes(v?.monitoring || '') &&
  !v.isBootDisk;

export const canBeUnDatafied = (v: Volume) => ['Managed'].includes(v?.monitoring || '');

export const isSwitchedOn = (v: Volume) =>
  ['Migrating', 'Growing', 'Shrinking', 'Merging', 'Managed'].includes(v?.monitoring || '');

// export const isProgressing = (v: Volume) =>
//   ['Migrating', 'Growing', 'Shrinking', 'Merging', 'Unmigrating'].includes(v?.monitoring || '');

export const isSwitchDisabled = (v: Volume) =>
  (!canBeDatafied(v) && !canBeUnDatafied(v)) || (isSwitchedOn(v) && v.monitoring !== 'Managed');

export type OptimisticSwitchType = { value: boolean; date: number; volId?: string }[];

export const updateOptimisticVolumeSwitch = (
  prevState: OptimisticSwitchType,
  volumeId: string,
  value?: boolean,
  date?: number
) => {
  if (value !== undefined && date) {
    if (prevState?.some((v) => v.volId === volumeId)) {
      return prevState.map((v) => {
        if (v?.volId === volumeId) {
          return { ...v, value, date };
        }

        return v;
      });
    }

    return [...(prevState || []), { value, date, volId: volumeId }];
  } else {
    return prevState.filter((v) => v?.volId !== volumeId);
  }
};

export function getApiFilterFromSelectOption(f: SelectOption) {
  return JSON.stringify({
    field: f.group,
    value: f.id,
    op: 'equals',
  });
}

export function datafyErrorToast(volumeId: Volume['volumeId']) {
  return toaster({
    variant: 'error',
    title: 'Datafication Error',
    message: `Volume ${volumeId} has failed to Datafy.`,
    toastId: volumeId,
  });
}
export const optmisticSwitchingInterval = 11000;
